export enum EKvorumEnums {
    POCET = 'POCET',
    NE = 'NE',
    PROCENTA = 'PROCENTA'
}
